import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api';
//import logo from '../../assets/logo.png'
import logo from '../../assets/SMYO_logo-31.png'
import { Spin } from 'antd';
import { displayMessage } from '../../services/helper';

const SplashScreen = () => {

    const {
        setIsAdmin,
        setLoggedUser,
        setUserPermissions,
        setUser, user,
        windowWidth, windowHeight,
    } = useContext(GeneralContext)

    const navigate = useNavigate()

    useEffect(() => {
        setTimeout(handleOnValidateSession, 1000);
    })

    const handleOnValidateSession = async () => {
        try {
            const token = localStorage.getItem('token')
            const currentUser_id = JSON.parse(localStorage.getItem('user'))?.id

            if (!token) {
                setLoggedUser(false)
                return
            }

            // const user = res.data

            // if (!user) {
            //     setLoggedUser(false)
            //     return
            // }

            await api.auth.setAuthorizationToken(token)
            const rs = await api.user.get(currentUser_id)
            setUser(rs.data)
            setLoggedUser(true)

        } catch (error) {
            console.log(`${displayMessage('ERROR_VALIDATION_SECTION')}: `, error)
            setLoggedUser(false)
        }
    }

    return (
        <div style={{ width: windowWidth, height: windowHeight, gap: 20, backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <div style={{ maxHeight: 350, maxWidth: 350, margin: 20 }}>
                <img
                    src={logo}
                />
            </div>
            <Spin size="default" />
            <span>{displayMessage('DEVELOPED_BY')} <span style={{ fontWeight: 'bold' }}> Solve Light</span> </span>
        </div>
    );
};

export default SplashScreen;